import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbDateParserFormatter, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../shared/adapters/datepicker-adapter';
import { CustomerService } from './shared/services/customer.service';
import { customerModel, customerTransactionModel } from './shared/models/customerModel';
import { CustomerProfileComponent } from './customer-profile/customer-profile.component';
import { environment } from 'src/environments/environment';
import { CustomerTransactionDetailsComponent } from './customer-transaction-details/customer-transaction-details.component';
import { CcPaymentReportService } from '../cc-payment-report/shared/services/cc-payment-report.service';

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class CustomerComponent implements OnInit {

  customerModel: customerModel;

  DateFrom: NgbDateStruct;
  DateTo: NgbDateStruct;
  custProfile: any;
  SearchCustomerSummary: any;
  maxDate: NgbDateStruct;
  InvoiceDetails : any;
  FranchiseList : any[] = [];

  constructor(private _modalSvc: NgbModal, private CustomerService: CustomerService, private ccPaymentReportService: CcPaymentReportService) { }

  ngOnInit() {
    this.resetForm();
    const current = new Date();
    this.maxDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
    // this.ccPaymentReportService.getCcPaymentReportFranchiseList().subscribe(response => {
    //   if (response) {
    //     this.FranchiseList = response?.FranchiseList;
    //   }

    // });
  }


  resetForm() {
    let from = new Date();
    let to = new Date();
    from.setDate(from.getDate() - 7);
    this.DateFrom = { year: from.getFullYear(), month: from.getMonth() + 1, day: from.getDate() }
    this.DateTo = { year: to.getFullYear(), month: to.getMonth() + 1, day: to.getDate() },
      this.customerModel = {
        DateFrom: (from.getMonth() + 1) + '/' + from.getDate() + '/' + from.getFullYear(),
        DateTo: (to.getMonth() + 1) + '/' + to.getDate() + '/' + to.getFullYear(),
        PageNo: 1,
        PageSize: 10,
        SearchString: "",
        FirstName : "",
        LastName : "",
        InvoiceNo : "",
        AccountNo : "",
        FranchiseId : '',
      };
    this.getCustomers(this.customerModel.PageNo);

  }

  clear() {
    this.resetForm();
  }

  getCustomers(PageNo: number) {
    this.customerModel.PageNo = PageNo;
    this.customerModel.DateFrom = this.DateFrom.month + '/' + this.DateFrom.day + '/' + this.DateFrom.year;
    this.customerModel.DateTo = this.DateTo.month + '/' + this.DateTo.day + '/' + this.DateTo.year;
    this.CustomerService.getdata(this.customerModel).subscribe(response => {
      if (response) {
        this.SearchCustomerSummary = response;
      }
    });

  }

  getCustomerProfile(customerId) {
    if (customerId) {
      this.CustomerService.getCustomerProfile(customerId).subscribe(CustomerProfile => {
        if (CustomerProfile) {
          this.custProfile = CustomerProfile;
          if (CustomerProfile.Customer.ImagePath) {
            this.custProfile.Customer.ImagePath = environment.config.rootUrl + CustomerProfile.Customer.ImagePath + "?" + new Date().getTime();
          }
          else {
            this.custProfile.Customer.ImagePath = "http://dcdbackoffice.ssasoft.com/images/editprofile.jpg";
          }         
          const modalRef = this._modalSvc.open(CustomerProfileComponent);
          modalRef.componentInstance.custProfile = this.custProfile;
        }
      });
    }
  }

  getCustomerTransactionDetail(customerId : any){
    let payLoad  = new customerTransactionModel();
    payLoad = { ...this.customerModel };
    payLoad.CustomerId = customerId;
    const modalRef = this._modalSvc.open(CustomerTransactionDetailsComponent);
      modalRef.componentInstance.payLoad = payLoad;
  }
}